import Vue from 'vue';

export default (type = 'create', params = {}) => (
  new Promise((resolve, reject) => {
    let request = null;
    if (type === 'create') {
      request = Vue.$http.post('organization_settings/low_stock_notification_recipients', params);
    } else if (type === 'show') {
      request = Vue.$http.get('organization_settings/low_stock_notification_recipients');
    } else if (type === 'destroy') {
      request = Vue.$http.delete(`organization_settings/low_stock_notification_recipients/${params.email}`);
    }
    request.then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(error.response.data);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/organizationSettings/lowStockNotificationRecipients.js